export const STEP_UP_PROPERTY = 'idwRiskScore.stepUp.minValue';
export const PASS_PROPERTY = 'idwRiskScore.pass.minValue';

export const STEP_UP_MINIMUM_VALUE = 50;

export const PASS_MINIMUM_VALUES = 70;
export const STEP_UP_LABELS: {[key: string]: string} = {
    [STEP_UP_PROPERTY]: 'Step Up',
    [PASS_PROPERTY]: 'Pass'
}
